import { rgb, StandardFonts } from 'pdf-lib';

export const bicfPdf = async (pdfDoc, data) => {
  // Replace [name]
  const page = pdfDoc.getPages()[0];
  const { width, height } = page.getSize();

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica, {
    subset: true,
    features: { liga: false },
  });

  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 198, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 100, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const bHeading = `During your employment with ${data.DSP_TRADENAME}, you may use biometric equipment (“Equipment”) for various business purposes, which may include recording your time worked, to enter or exit rooms, or to access equipment, items or information. This policy and consent form explains how the ${data.DSP_TRADENAME} may collect, store, use, disclose and destroy a scan of your finger, hand, face, retina or iris, or your voiceprint in compliance with the Biometric Information Privacy Act or applicable law and supplements any prior communications and policies that relate to this subject.`;

  page.drawText(bHeading, {
    x: 72, // X position of the placeholder
    y: height - 105, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
    font,
    maxWidth: width - 140,
  });
  /////

  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 558, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 240, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const bBody = `Depending on the Equipment used, your Mathematical Representation is housed on Equipment and/or servers (“Server”) that are maintained and secured by the ${data.DSP_TRADENAME} or third-party vendors (“Vendors”). The ${data.DSP_TRADENAME} and its Vendors treat your Mathematical Representation as confidential and sensitive information and exercise reasonable care to store, transmit and protect your Mathematical Representation from disclosure to unauthorized third-parties.\nThe ${data.DSP_TRADENAME} and its Vendors will not sell, lease, trade or otherwise profit from your Mathematical Representation. The ${data.DSP_TRADENAME} and its Vendors will not disclose your Mathematical Representation unless required by law; the disclosure completes a financial transaction authorized by you or your authorized representative; or you otherwise consent to the disclosure.\nIf the ${data.DSP_TRADENAME} or its Vendorsservice the Equipment, Server or software, you consent to disclosing your Mathematical Representation or otherwise giving them access to it to make the repair, maintenance, upgrade or change, or to destroy your Mathematical Representation. Your Mathematical Representation will be timely destroyed within 90 days of the earlier of when your use of the Equipment ends or your employment ends, or in accordance with applicable law, unless a longer retention period is required.`;

  page.drawText(bBody, {
    x: 72, // X position of the placeholder
    y: height - 327, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width - 140,
  }); ///
  page.drawRectangle({
    x: 482, // X position of the background
    y: height - 627, // Y position of the background
    width: 60, // Width of the background box (adjust as needed)
    height: 13, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  page.drawText(data.DSP_TRADENAME, {
    x: 483, // X position of the placeholder
    y: height - 624, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width - 140,
  }); ///

  const footer = `policy, understand it, agree to abide by it and voluntarily consent to the ${data.DSP_TRADENAME}’s and/or the Vendors’ collection, storage, use, disclosure and destruction of my Mathematical Representation, effective the first date I used the Equipment. `;
  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 668, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 40, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  //
  page.drawText(footer, {
    x: 72, // X position of the placeholder
    y: height - 638, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width - 140,
  }); ///

  page.drawText(data.SUFFIX + data.NAME, {
    x: 325, // X position of the placeholder
    y: height - 690, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });
  page.drawText(data.DATE, {
    x: 235, // X position of the placeholder
    y: height - 690, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });

  // //////

  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      page.drawSvgPath(pathString, {
        x: 72,
        y: height - 650,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
    });
  }
};
